/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_On_Every_ArticleInputs */

const en_onboarding_results_on_every_article = /** @type {(inputs: Onboarding_Results_On_Every_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`on every article`)
};

const es_onboarding_results_on_every_article = /** @type {(inputs: Onboarding_Results_On_Every_ArticleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`en cada artículo`)
};

/**
* | output |
* | --- |
* | "on every article" |
*
* @param {Onboarding_Results_On_Every_ArticleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_on_every_article = /** @type {((inputs?: Onboarding_Results_On_Every_ArticleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_On_Every_ArticleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_on_every_article(inputs)
	return en_onboarding_results_on_every_article(inputs)
});